import { render, staticRenderFns } from "./TheDisclaimer.vue?vue&type=template&id=2a6147aa&scoped=true&"
import script from "./TheDisclaimer.vue?vue&type=script&lang=js&"
export * from "./TheDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./TheDisclaimer.vue?vue&type=style&index=0&id=2a6147aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6147aa",
  null
  
)

export default component.exports